document.addEventListener("DOMContentLoaded", function () {
  function applypreOrder() {
    const inventoryScript = document.getElementById("ProductJson");
    const inventoryData = JSON.parse(inventoryScript.textContent);
    var selectedWidth = document.querySelector(
      'input[name="Width"]:checked'
    )?.value;
    inventoryData.forEach((variant) => {
      if (
        variant.inventory_quantity === 0 &&
        selectedWidth == variant.option1
      ) {
        document
          .querySelector('input[name="Size"][value="' + variant.option2 + '"]')
          .classList.add("preOrder");
      }
    });
    inventoryData.forEach((variant) => {
      if (variant.inventory_quantity != 0 && selectedWidth == variant.option1) {
        document
          .querySelector('input[name="Size"][value="' + variant.option2 + '"]')
          .classList.remove("preOrder");
      }
    });
  }
  applypreOrder();
  document.querySelectorAll('input[name="Width"]').forEach((Ele) => {
    Ele.addEventListener("change", function () {
      applypreOrder();
    });
  });

  function checkPreorderStatus() {
    const deliveryPromise = document.querySelector("delivery-promise-wc");
    const shipToday = document.querySelector(".ship-today");
    const preorderDesc = document.querySelector(
      ".restock-rocket-preorder-description"
    );
    const addToCartButton = document.querySelector(
      "#AddToCart .single-add-to-cart-button--text"
    );

    if (preorderDesc) {
      if (addToCartButton) {
        addToCartButton.textContent = "Preorder & Save 10%";
      }

      if (deliveryPromise) {
        deliveryPromise.classList.add("preOrderNone");
      }

      if (shipToday) {
        shipToday.style.display = "none";
      }
    } else {
      if (deliveryPromise) {
        deliveryPromise.classList.remove("preOrderNone");
      }

      if (shipToday) {
        shipToday.style.display = "block";
      }
    }
  }

  document.addEventListener("change", function (event) {
    if (event.target.classList.contains("variation-option-radio")) {
      setTimeout(checkPreorderStatus, 1000); // Give time for DOM to update
    }
  });

  window.addEventListener("DOMContentLoaded", function () {
    setTimeout(checkPreorderStatus, 1000); // Wait in case DOM updates late
  });
});

if (!customElements.get("desktop-tabs")) {
  customElements.define( "desktop-tabs", class DesktopTabs extends HTMLElement {
      constructor() {
        super();

        this.tabs = this.querySelectorAll('.js-desktop-tabs__tab-button');
        this.contentWrappers = this.querySelectorAll('.js-desktop-tabs__content');
      }

      connectedCallback() {
        this.tabs.forEach(tab => {
          tab.addEventListener('change', this.changeTabEventHandler);
        })
      }

      disconnectedCallback() {
        this.tabs.forEach(tab => {
          tab.removeEventListener('change', this.changeTabEventHandler);
        })
      }

      changeTabEventHandler = (event) => {
        const currentTab = event.target.closest('.js-desktop-tabs__tab-button').value;

        this.contentWrappers.forEach(contentWrapper => {
          const tabHandle = contentWrapper.dataset.tab;

          if (currentTab === tabHandle) {
            contentWrapper.classList.add('is-active');
          } else {
            contentWrapper.classList.remove('is-active');
          }
        })
      }
    }
  );
}